<h2 mat-dialog-title>{{'reporteditDdialog.confirmation' | translate}}</h2>
<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <p>{{'reporteditDdialog.mustfillrequiredField' | translate}}</p>
</div>
<div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
  <mat-dialog-actions>
    <button mat-raised-button color="primary" [mat-dialog-close]="'yes'">{{'reporteditDdialog.ok' | translate}}</button>
  </mat-dialog-actions>
</div>